import useMediaQuery from 'hooks/useMediaQuery'
import useQueryString from 'hooks/useQueryString'
import 'styles/aspaec-theme.css'
import { MOBILE_WIDTH } from 'utils/constants'
import AccountSidePanel from './components/template/AccountSidePanel'
import PageToRender from './components/template/PageToRender'
import * as Styles from './styles'

function AccountAssociation() {
  const { filters } = useQueryString()
  const isMobile = useMediaQuery(MOBILE_WIDTH)

  return (
    <Styles.AccountContainer className="aspaec-theme" isMobile={isMobile}>
      {/* <BackToPanelLink page={filters.pagina} /> */}
      <Styles.AccountContent>
        {!isMobile && <AccountSidePanel />}
        <PageToRender page={filters.pagina} />
      </Styles.AccountContent>
    </Styles.AccountContainer>
  )
}

export default AccountAssociation
